var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.1663 35.875V32.4583C34.1663 30.646 33.4464 28.9079 32.1649 27.6264C30.8834 26.3449 29.1453 25.625 27.333 25.625H13.6663C11.854 25.625 10.1159 26.3449 8.83444 27.6264C7.55295 28.9079 6.83301 30.646 6.83301 32.4583V35.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5003 18.7917C24.2743 18.7917 27.3337 15.7323 27.3337 11.9583C27.3337 8.18439 24.2743 5.125 20.5003 5.125C16.7264 5.125 13.667 8.18439 13.667 11.9583C13.667 15.7323 16.7264 18.7917 20.5003 18.7917Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.827c4a226907af8264071af45706808e.svg";
export { ForwardRef as ReactComponent };